export function tabItem() {
  document.addEventListener("DOMContentLoaded", function () {
    const $ = document.querySelector.bind(document);
    const $$ = document.querySelectorAll.bind(document);

    const tabs = $$(".tab-item");
    const panes = $$(".tab-pane");
    const buttons = $$(".tab-button");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        // Xóa class active khỏi tất cả các button
        buttons.forEach((btn) => btn.classList.remove("active"));

        // Thêm class active vào button được nhấn
        button.classList.add("active");
      });
    });

    // Kiểm tra nếu phần tử .line tồn tại trước khi thao tác với nó
    if (tabs.length > 0 && panes.length > 0) {
      tabs.forEach((tab, index) => {
        const pane = panes[index];
        tab.onclick = function () {
          // Ẩn tất cả các phần tử đang được hiển thị
          $(".tab-item.show")?.classList.remove("show");
          $(".tab-pane.show")?.classList.remove("show");

          // Hiển thị tab và pane tương ứng
          this.classList.add("show");
          pane.classList.add("show");
        };
      });
    } else {
      console.error("Không tìm thấy các phần tử cần thiết.");
    }
  });
}

tabItem();
